import { render, staticRenderFns } from "./BizTime.vue?vue&type=template&id=6cceac72&scoped=true&"
import script from "./BizTime.vue?vue&type=script&lang=js&"
export * from "./BizTime.vue?vue&type=script&lang=js&"
import style0 from "./BizTime.vue?vue&type=style&index=0&id=6cceac72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cceac72",
  null
  
)

export default component.exports